import React, { useState } from "react";
import { api, errMsg, GRADE_LABELS } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/common";
import { TeacherCredentials } from "@/components/Credentials";
import { GradeSelect } from "@/pages/AuthPage";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Copy, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Profile() {
  const { user, setUser } = useAuth();
  const [name, setName] = useState(user.name);
  const [grade, setGrade] = useState(user.grade_band || "");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.patch("/auth/me", { name, grade_band: user.role === "student" ? grade : null });
      setUser(data);
      toast.success("Profile saved");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-2xl">
      <PageHeader eyebrow="Profile" title="Your profile" />
      <div className="bg-white border border-border rounded-[18px] p-6 sm:p-8 space-y-5">
        <div className="space-y-2"><Label>Name</Label><Input value={name} onChange={(e) => setName(e.target.value)} className="h-11" data-testid="profile-name-input" /></div>
        <div className="space-y-2"><Label>Email</Label><Input value={user.email} disabled className="h-11" /></div>
        <div className="space-y-2"><Label>Role</Label><Input value={user.role} disabled className="h-11 capitalize" data-testid="profile-role" /></div>
        {user.role === "student" && (
          <>
            <div className="space-y-2"><Label>Grade level</Label><GradeSelect value={grade} onChange={setGrade} testid="profile-grade-select" /><p className="text-xs text-muted-foreground">Currently: {GRADE_LABELS[user.grade_band]}. Sage adjusts how it explains things to this level.</p></div>
            <div className="bg-[#FFF1C7] border border-[#F2B705]/30 rounded-[14px] p-4 flex items-center gap-3">
              <div className="flex-1"><div className="text-sm font-semibold">Parent link code</div><div className="font-display text-2xl tracking-[0.2em] font-semibold" data-testid="profile-link-code">{user.link_code}</div></div>
              <Button variant="ghost" size="icon" aria-label="Copy code" onClick={() => { navigator.clipboard?.writeText(user.link_code); toast.success("Code copied"); }}><Copy className="h-4 w-4" /></Button>
            </div>
          </>
        )}
        <Button className="h-11" onClick={save} disabled={busy} data-testid="profile-save-button">{busy && <Loader2 className="h-4 w-4 animate-spin mr-2" />}Save changes</Button>
      </div>
      {user.role === "teacher" && <TeacherCredentials />}
    </div>
  );
}
